/**
 * Landing-/Hero-Branding: VeWorld und schmale Viewports sollen nur das
 * kompakte VeWorld-Icon sehen, damit kein Scraping auf große Textlogos im DOM zielt.
 */
export function shouldUseMobileBrandHeroLogo() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  const isVeWorldLike = /VeWorld|veworld/i.test(navigator.userAgent || "");
  let isMobileViewport = false;
  try {
    isMobileViewport = Boolean(window.matchMedia("(max-width: 768px)").matches);
  } catch {
    /* ignore */
  }
  return isVeWorldLike || isMobileViewport;
}
